import React from 'react'
import { ButtonProps } from '@/types'

const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  type = 'button',
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  className = '',
}) => {
  const baseClasses =
    'font-medium rounded-xl transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-offset-1 inline-flex items-center justify-center touch-manipulation select-none'

  const variantClasses = {
    primary: 'bg-gradient-primary text-white hover:opacity-90 focus:ring-secondary-400',
    secondary:
      'bg-white text-primary-700 border border-primary-200 hover:bg-primary-50 focus:ring-primary-400',
    danger: 'bg-red-500 text-white hover:bg-red-600 focus:ring-red-400',
    ghost: 'bg-transparent text-primary-600 hover:bg-primary-50 focus:ring-primary-400',
  }

  const sizeClasses = {
    sm: 'px-2.5 py-1.5 text-sm gap-1.5',
    md: 'px-3.5 py-2 text-sm gap-2',
    lg: 'px-4 py-2.5 text-base gap-2',
  }

  const disabledClasses = disabled || loading ? 'opacity-50 cursor-not-allowed' : ''
  const buttonClasses = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses} ${className}`

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={(e) => {
        if (disabled || loading) return
        onClick?.(e)
      }}
      disabled={disabled || loading}
      style={{ touchAction: 'manipulation' }}
    >
      {loading && (
        <span
          className="w-3.5 h-3.5 border-2 border-current border-t-transparent rounded-full animate-spin shrink-0"
          aria-hidden
        />
      )}
      {children}
    </button>
  )
}

export default Button
